import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import invariant from 'tiny-invariant';
import type {
    RemoveInspirationMutation,
    RemoveInspirationMutationVariables,
} from 'generated/graphql';
import { RemoveInspirationDocument } from 'generated/graphql';

export const REMOVE_BUILD_HUB_INSPIRATION_API_ROUTE =
    '/remix-api/app/build-hub-inspiration-remove';

const DEFAULT_FAILED_MESSAGE = 'Failed to remove BuildHub inspiration.';

/**
 * Action to remove a new inspiration group from the build hub.
 */
export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('id'), 'No BuildHub ID submitted for update.');
    invariant(
        data.get('inspirationGroupId'),
        'No inspiration group ID submitted for remove.'
    );

    const variables: RemoveInspirationMutationVariables = {
        BuildHubID: data.get('id') as string,
        InspirationGroupID: data.get('inspirationGroupId') as string,
    };

    try {
        const { data: result } = await context.client.mutate<
            RemoveInspirationMutation,
            RemoveInspirationMutationVariables
        >({
            mutation: RemoveInspirationDocument,
            variables,
        });

        const validResult = result?.projectInspirationGroupRemove;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
